export const SaadPortfolio = () => {
  const pdfUrl = `${window.location.origin}/api/portfolio-pdf`;
  return (
    <div style={{ width: "100vw", height: "100vh", margin: 0, padding: 0, overflow: "hidden" }}>
      <iframe
        src={pdfUrl}
        title="Saad Portfolio"
        style={{ width: "100%", height: "100%", border: "none" }}
        data-testid="portfolio-pdf-viewer"
      />
    </div>
  );
};
